import Request from "@/common/net/request.js";
const request = new Request();
// 列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/settlement/agent/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 代理商结算单结算
export function reconcile(data) {
  return request.send({
    url: `/pmy/freight/settlement/agent/settle`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 对账单详情中的订单列表
export function reconciliationOrders(data) {
  return request.send({
    url: `/pmy/freight/settlement/agent/info/orders`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 对账单详情
export function reconciliationOrderDetail(data) {
  return request.send({
    url: `/pmy/freight/settlement/agent/info?billId=${data.billId}`,
    method: "get",
  });
}

// 代理商结算单详情导出
export function downloadDetail(data) {
  return request.send({
    url: `/pmy/freight/settlement/agent/info/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 代理商结算单列表导出
export function downloadTable(data) {
  return request.send({
    url: `/pmy/freight/settlement/agent/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 代理商结算单统计总览
export function overview(data) {
  return request.send({
    url: `/pmy/freight/settlement/agent/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 删除
export function deleteInfo(billId) {
  return request.send({
    url: `/pmy/freight/settlement/agent?billId=${billId}`,
    method: "delete"
  });
}
